import { ToastSeverity } from '../../ui/gzToastNotification/type';
import { GzToastNotificationWebComponent } from '../../ui/gzToastNotification';

export function showToast(severity: ToastSeverity, message: string) {
  GzToastNotificationWebComponent.buildToastWrapperElement({
    message: message,
    severity: severity,
  });
}
